<template>
  <v-menu :min-width="100" bottom left v-bind="$props">
    <template v-slot:activator="{ on, attrs }">
      <v-btn :small="small" v-bind="attrs" icon v-on="on">
        <v-icon :small="small">more_vert</v-icon>
      </v-btn>
    </template>

    <v-list dense>
      <slot />
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'MoreMenu',
  props: {
    small: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
